import createSvgIcon from "./utils/createSvgIcon";

export default createSvgIcon(
  <>
    <path fillOpacity=".3" d="M2 22h20V2z"></path>
    <path d="M17 7.5L2 22h15z"></path>
  </>,
  "SignalCellular4Bar"
);
